import React from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import HelpToolTip from "../../components/HelpToolTip";

import "./style.scss";

class FieldSelect extends React.Component {
  handleChange = (event, element) => {
    this.props.onChange({name: this.props.name, value: element.props.value});
  };

  render() {
    const _props = {...this.props};
    _props.onChange = this.handleChange;
    const options = [..._props.options];
    delete _props.options;
    return (
      <div style={{position: "relative"}}>
        {_props.label ? <InputLabel style={{fontSize: "75%"}}>{_props.label}</InputLabel> : null}
        <Select fullWidth {..._props}>
          {options.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              <Grid container style={{width: "100%"}}>
                {option.image && (
                  <Grid item xs={3}>
                    <img src={option.image} alt="" />
                  </Grid>
                )}
                <Grid item xs={9} style={{marginTop: "10px"}}>
                  {option.text}
                  {option.secondaryText && <div className="secondaryText">{option.secondaryText}</div>}
                </Grid>
              </Grid>
            </MenuItem>
          ))}
        </Select>
        {this.props.tooltip && (
          <HelpToolTip style={{position: "absolute", top: 12, left: 0}} tip={this.props.tooltip} />
        )}
      </div>
    );
  }
}

export default FieldSelect;



// WEBPACK FOOTER //
// ./src/components/FieldSelect/index.jsx